const appConfig = {
    appId: "marketQore-82fdbc8f-5104-48a8-bc56-aa5ea1d4db2a",
    appName: "Market",
    site: 'market-qore',
    icon: "https://nsdstaticasset.blob.core.windows.net/assets/Qore_Brand_Icons/marketQoreAppIcon.png"
};

export default appConfig;
